import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8 21q-.824 0-1.412-.587A1.93 1.93 0 0 1 6 19v-2H4q-.824 0-1.413-.587A1.93 1.93 0 0 1 2 15v-4q0-1.275.875-2.137T5 8h14q1.276 0 2.137.863Q22 9.725 22 11v4q0 .824-.587 1.413A1.93 1.93 0 0 1 20 17h-2v2q0 .824-.587 1.413A1.93 1.93 0 0 1 16 21zm-4-6h2q0-.825.588-1.412A1.93 1.93 0 0 1 8 13h8q.824 0 1.413.588Q18 14.175 18 15h2v-4a.97.97 0 0 0-.288-.713A.97.97 0 0 0 19 10H5a.97.97 0 0 0-.713.287A.97.97 0 0 0 4 11zm12-7V5H8v3H6V5q0-.824.588-1.413A1.93 1.93 0 0 1 8 3h8q.824 0 1.413.587.586.589.587 1.413v3zm2 4.5a.97.97 0 0 0 .712-.287A.97.97 0 0 0 19 11.5a.97.97 0 0 0-.288-.713A.97.97 0 0 0 18 10.5a.97.97 0 0 0-.712.287.97.97 0 0 0-.288.713q0 .424.288.713A.97.97 0 0 0 18 12.5M16 19v-4H8v4z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render: render }